var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h3',[_vm._v("Référentiel")]),_c('nested-draggable',{attrs:{"tasks":_vm.list,"parameters":_vm.parameters}}),_c('b-button',{on:{"click":function($event){_vm.list.push({
					id: _vm.unique_id(),
					data: {},
					tasks: [],
					show: true,
					first_deep: 0,
				})}}},[_vm._v("Ajouter")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }